import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ForwardOutlinedSvg from "@ant-design/icons-svg/es/asn/ForwardOutlined";
import AntdIcon from "../components/AntdIcon";
var ForwardOutlined = function ForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ForwardOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ForwardOutlined.displayName = 'ForwardOutlined';
}
export default /*#__PURE__*/React.forwardRef(ForwardOutlined);